var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgValidationX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 6,
  height: 6
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M5.557.497a.75.75 0 0 1-.006 1.06L4.067 3.023 5.551 4.49a.75.75 0 1 1-1.054 1.067L3 4.078l-1.497 1.48A.75.75 0 0 1 .45 4.49l1.483-1.467L.449 1.557A.75.75 0 1 1 1.503.49L3 1.97 4.497.49a.75.75 0 0 1 1.06.007"
})));
export { SvgValidationX as ReactComponent };
export default __webpack_public_path__ + "static/media/validation-x.d0726586.svg";